import { element } from 'angular';

/**
 * @ngdoc method
 * @name util#downloadJSONFile
 * @description
 * Download a JSON file
 * @param {string} data The stringify JSON
 * @param {string} fileName The name of the downloaded file
 */
export function downloadJSONFile(data: string, fileName: string = 'file') {
  let blob = new Blob([data], { type: 'application/json' });
  let filename = fileName + '.json';
  let docBody = element(document.body);
  let downloadLink = element('<a></a>');
  downloadLink.attr('href', window.URL.createObjectURL(blob));
  downloadLink.attr('target', '_self');
  downloadLink.attr('download', filename);
  docBody.append(downloadLink);
  downloadLink[0].click();
  downloadLink.remove();
}
